import {SearchItem, SearchResultDto} from "./search-table.dto.res";
import {TextTemplateDto} from "../text-template.dto";

export class SearchTextTemplateRes extends SearchResultDto {

  public override readonly items: SearchTextTemplateItem[] = [];

  constructor(init?: Partial<SearchTextTemplateRes>) {
    super(init);
    if (init?.items) {
      this.items = init.items.map((i) => new SearchTextTemplateItem(i));
    } else {
      this.items = [];
    }
  }
}

export class SearchTextTemplateItem extends TextTemplateDto implements SearchItem {

  public override readonly id!: string;

  constructor(init?: Partial<SearchTextTemplateItem>) {
    super(init);
    Object.assign(this, init);
  }

  public isEditable(): boolean {
    return true;
  }
}
